import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { NcisBasemapType } from 'app/models/enums';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const sendMstToNcisUrl = contractId => `${environment.apiUrl}/ncis/mst/${contractId}`;
const sendFcdToNcisUrl = ncisContractId => `${environment.apiUrl}/ncis/mst/fcd/${ncisContractId}`;
const createTaskSendFcdToNcisUrl = ncisContractId => `${environment.apiUrl}/ncis/mst/fcd/${ncisContractId}/createtask`;
const sendBasemapToNcisUrl = ncisBasemapType => `${environment.apiUrl}/ncis/basemap/${ncisBasemapType}`;

@Injectable()
export class MstToNcisService {
  constructor(private readonly httpService: HttpService) {}

  sendMstToNcis(contractid: number): Observable<Response> {
    return this.httpService.post(sendMstToNcisUrl(contractid), '');
  }

  sendFcdToNcis(ncisContractId: number): Observable<Response> {
    return this.httpService.post(sendFcdToNcisUrl(ncisContractId), '');
  }

  createTaskSendFcdToNcis(ncisContractId: number): Observable<Response> {
    return this.httpService.post(createTaskSendFcdToNcisUrl(ncisContractId), '');
  }

  sendBasemapToNcis(ncisBasemapType: NcisBasemapType): Observable<Response> {
    return this.httpService.post(sendBasemapToNcisUrl(ncisBasemapType), '');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mstToNcis.service.ts